/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FavoriteMutationResponse } from '../models/FavoriteMutationResponse';
import type { FavoritesListResponse } from '../models/FavoritesListResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FavoritesService {
    /**
     * List current account favorites
     * @returns FavoritesListResponse Favorite catalog items
     * @throws ApiError
     */
    public static getApiV1MeFavorites(): CancelablePromise<FavoritesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/me/favorites',
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Add item to current account favorites
     * @returns FavoriteMutationResponse Favorite state updated
     * @throws ApiError
     */
    public static putApiV1MeFavorites({
        itemId,
    }: {
        itemId: string,
    }): CancelablePromise<FavoriteMutationResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/me/favorites/{itemId}',
            path: {
                'itemId': itemId,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Remove item from current account favorites
     * @returns FavoriteMutationResponse Favorite state updated
     * @throws ApiError
     */
    public static deleteApiV1MeFavorites({
        itemId,
    }: {
        itemId: string,
    }): CancelablePromise<FavoriteMutationResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/me/favorites/{itemId}',
            path: {
                'itemId': itemId,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
}
